import request from '@/utils/request'

// 获取用户详细信息
export function lineChart(data) {
  return request({
    url: '/statistic/lineChart',
    method: 'post',
    data:data,
    headers: {
        'Content-Type': 'application/json'
    }
  })
}


